import { Url } from '@/constants';
import BaseApi from './base';

const getSidebarData = async (pageName: string) => {
  let response = await BaseApi.get(`${Url.localBaseUrl}/data/staticContent.json`, {});
  response = response.filter((item: any) => {
    return item.name.toLowerCase() === pageName.toLowerCase();
  })[0];
  return response.data || null;
};

const getMockPhase = () => BaseApi.get(`${Url.localBaseUrl}/data/CMSPhaseContent.json`, {});

export { getSidebarData, getMockPhase };
